import { useCallback, useState } from 'react'
import { downloadBlobAsFile } from '../utils/downloadBlobAsFile'
import { fetchPaymentData } from '../../../api/salaryCalculation'
import { Moment } from 'moment'

export const useGetLatestPayments = (date: Moment) => {
  const [paymentsLoading, setPaymentsLoading] = useState(false)
  const downloadLatestPayments = useCallback(() => {
    setPaymentsLoading(true)

    fetchPaymentData(date.format('YYYY-MM-DD'))
      .then(({ data, fileName }) => {
        const blob = new Blob([data])

        downloadBlobAsFile(blob, fileName)

        setPaymentsLoading(false)
      })
      .catch((e) => {
        console.error(`Error when fetching payment data: ${e}`)
        setPaymentsLoading(false)
      })
  }, [setPaymentsLoading, date])

  return { paymentsLoading, downloadLatestPayments }
}
